import Button from '@material-ui/core/Button'
import React from 'react'

type ViewDatasetDescriptionProps = {
  text: string
  onOpenEdit: () => void
}
export const ViewDatasetDescription: React.FC<ViewDatasetDescriptionProps> = ({ text, onOpenEdit }) => {
  return (
    <div>
      {text}
      <div style={{ margin: '12px auto' }}>
        <Button variant={'contained'} color="primary" onClick={onOpenEdit}>
          {/*<p className={classes.SubmitButtonText}>*/}
          {/*<EditIcon />*/}
          Edit description
          {/*</p>*/}
        </Button>
      </div>
    </div>
  )
}
